import { render, staticRenderFns } from "./lembreteModal.vue?vue&type=template&id=76596473"
import script from "./lembreteModal.vue?vue&type=script&lang=js"
export * from "./lembreteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports